<h2 class="font-weight-normal">Добавить наиболее популярную услугу</h2>
<div class="table-align-center table-fluid mb-4">
  <div>
    <div>Услуга</div>
    <div>
      <dx-select-box
        [dataSource]="this.searchDataSource"
        [(value)]="this.selectedMenuItem"
        displayExpr="nameUa"
        placeholder="{{ 'SEARCH_IT_SERVICE' | translate }}"
        [minSearchLength]="0"
        [searchEnabled]="true"
        [searchTimeout]="500"
        [showClearButton]="true"
        animationEnabled="false"
        id="searchDataSourceId"
        class="search-dx-select-box mdi mdi-magnify">
        <div *dxTemplate="let data of 'item'" class="custom-item catalog-photo" style="white-space: pre-wrap">
          <div class="d-flex">
            <div class="me-3">
              @if (data.iconBody) {
                <img
                  style="width: 60px"
                  [src]="this.sanitizer.bypassSecurityTrustResourceUrl('data:' + data.iconType + ';base64,' + data.iconBody)" />
              }
              @if (!data.iconBody) {
                <img style="width: 60px" src="../../../../../assets/images/nophoto.png" />
              }
            </div>
            <div>
              <div>{{ data.nameRu }}</div>
              <div class="category color-black" style="font-size: 80%; color: #091e42">
                {{ data.category.nameRu }}
              </div>
            </div>
          </div>
        </div>
      </dx-select-box>
    </div>
  </div>
  <div>
    <div>Приоритет</div>
    <div>
      <dx-number-box [(value)]="this.entity.rank" [min]="0" [max]="1000" [showSpinButtons]="true"></dx-number-box>
    </div>
  </div>
</div>

<dx-button
  text="{{ 'SAVE' | translate }}"
  icon="save"
  class="btn btn-light"
  [disabled]="!this.selectedMenuItem"
  (onClick)="this.save()"></dx-button>
